import logo from '../img/logo.png'
import award1 from '../img/awards/1.png'
import award2 from '../img/awards/2.png'
import award3 from '../img/awards/3.png'
import banner1 from '../img/banner/home/1.png'
import banner2 from '../img/banner/home/2.png'
import homeaward from '../img/bg/home/home-award.jpg'
import homebanner from '../img/bg/home/home-banner.jpg'
import specialcake from '../img/bg/home/special-cake.png'
import badgenew from '../img/bg/badge-new.png'
import badgesale from '../img/bg/bagde-sale.png'
import badgesalelarge from '../img/bg/bagde-sale-large.png'
import homeabout from '../img/bg/home-about.jpg'
import specialcakehover from '../img/bg/special-cake-hover.png'
import tesmontials from '../img/bg/testimonials.jpg'
import hero from '../img/hero/shop-hero.png'
import about from '../img/homepage/home-1/home-about.png'
import sign from '../img/homepage/home-1/signature.png'
import firstproduct from '../img/product/1.png'
import coockerAbout from '../img/homepage/home-3/home-about.png'
import bestServicesLeft from '../img/homepage/home-6/instagram/1.jpg'
import bestServicesRight from '../img/section/book-your-tables/bg.jpg'
import goodBaker from '../img/homepage/home-3/good-baker.png'
import hero1 from '../img/users/bakers/1.png'
import hero2 from '../img/users/bakers/2.png'
import hero3 from '../img/users/bakers/3.png'



export const images = {
    logo,
    award1,
    award2,
    award3,
    banner1,
    banner2,
    homeaward,
    homebanner,
    specialcake,
    badgenew,
    badgesale,
    badgesalelarge,
    homeabout,
    specialcakehover,
    tesmontials,
    hero,
    about,
    sign,
    firstproduct,
    coockerAbout,
    bestServicesLeft,
    bestServicesRight,
    hero1,
    hero2,
    hero3,
    goodBaker,
  };